import type { EntryPoint, RequestOrigin, SourceMfe } from '@servicetitan/financing-api-client';
import type { ApplicationKind } from './resolveApplicationAttribution';

export interface FinancingAttribution {
    origin?: RequestOrigin;
    entryPoint?: EntryPoint;
    sourceMfe?: SourceMfe;
    provider?: string;
    applicationKind?: ApplicationKind;
    isHardAppFlow?: boolean;
}

let financingAttribution: FinancingAttribution = {};

const publishFinancingAttribution = (attribution: FinancingAttribution) => {
    window.DD_RUM?.setGlobalContextProperty?.('financingAttribution', attribution);
};

export const getFinancingAttribution = () => financingAttribution;

export const setFinancingAttribution = (partial: Partial<FinancingAttribution>) => {
    financingAttribution = {
        ...financingAttribution,
        ...(partial.origin !== undefined ? { origin: partial.origin } : {}),
        ...(partial.entryPoint !== undefined ? { entryPoint: partial.entryPoint } : {}),
        ...(partial.sourceMfe !== undefined ? { sourceMfe: partial.sourceMfe } : {}),
        ...(partial.provider !== undefined ? { provider: partial.provider } : {}),
        ...(partial.applicationKind !== undefined
            ? { applicationKind: partial.applicationKind }
            : {}),
        ...(partial.isHardAppFlow !== undefined ? { isHardAppFlow: partial.isHardAppFlow } : {}),
    };
    publishFinancingAttribution(financingAttribution);
};

export const resetFinancingAttribution = () => {
    financingAttribution = {};
};
